import { supabase } from './supabase';

export const isAdmin = async (email: string): Promise<boolean> => {
  if (!email) return false;
  
  try {
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('is_admin, has_lifetime_access')
      .eq('email', email)
      .single();

    if (error) {
      console.error('Supabase query error:', error);
      return false;
    }

    // Set lifetime access for admin users
    if (profile?.is_admin && !profile?.has_lifetime_access) {
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ has_lifetime_access: true })
        .eq('email', email);

      if (updateError) {
        console.error('Error updating lifetime access:', updateError);
      }
    }

    return profile?.is_admin || false;
  } catch (error) {
    console.error('Error in isAdmin check:', error);
    return false;
  }
};

export const updateUserAccess = async (userId: string, hasLifetimeAccess: boolean): Promise<boolean> => {
  if (!userId) return false;

  try {
    const { error } = await supabase
      .from('profiles')
      .update({ has_lifetime_access: hasLifetimeAccess })
      .eq('id', userId);

    if (error) {
      console.error('Error updating user access:', error);
      return false;
    }
    return true;
  } catch (error) {
    console.error('Error updating user access:', error);
    return false;
  }
};